"use client"
import React, {useState, useEffect} from 'react'
import style from "./hamburgeroverlaymenu.module.scss";
import {GiHamburgerMenu} from "react-icons/gi";
import {useTekstClient} from "hooks/useTekstClient";
import { useSWRConfig} from "swr"
import {useAxios} from "../../../hooks/useAxios";
import LocalizedLinkClient from "../../LocalizedLink/LocalizedLinkClient";
import {reverseTranslateSegments, translateSegments} from "../../../lib/pathTranslation";

export default function HamburgerOverlayMenu({ isTop,isMkgEu, locale = "en-GB" }) {

    const {get} = useAxios();
    const [showOverlayMenu, setShowOverlayMenu] = useState(false)
    const {tekst} = useTekstClient()

    const {mutate} = useSWRConfig()
    const [vertalingData, setVertalingData] = useState()

    useEffect(() => {
        get('/released/languages')
            .then((res) => {
                const dataLang = []

                res.data.forEach((d) => {
                    const obj = {
                        id: d.id,
                        taal: d.naam,
                        img_path: `fi fi-${d.alpha_code?.toLowerCase()}`,
                        displayImage: true
                    }

                    dataLang.push(obj)
                })

                setVertalingData(dataLang)
            })
    }, []);

    function handleClose() {
        setShowOverlayMenu(false)
    }


    function getRegionFromLocale(locale) {
        if (typeof locale !== 'string') return null;

        const parts = locale.split('-');
        return parts.length === 2 ? parts[1].toUpperCase() : null;
    }


    return <div className={style.hamburgerMenuContainer}>
        {isMkgEu ? <div onClick={() => setShowOverlayMenu(true)} className={`${style.hamburger} ${!isTop ? style.hamburgerBlue : ''}`}>
            <GiHamburgerMenu/>
        </div> : <div onClick={() => setShowOverlayMenu(true)} className={`${style.menuItem} asLink`}>{tekst('algemeen:menu:Menu')}</div>}

            <div className={`${style.overlayMenu} ${showOverlayMenu ? style.overlayMenuShow : ''}`}>
                {showOverlayMenu && <div className={style.menuContainer}>


                    <div className={`${style.menuClose}`} onClick={handleClose}/>


                    <ul className={style.ulMainNav}>
                        <li>
                            <LocalizedLinkClient href={`/`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:home:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mkg3-erp-software`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:mkg3erp:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mkg5-erp-systeem`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:mkg5erp:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mkg5-erp-pakket`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:mkg5erpsysteem:linktekst')}
                            </LocalizedLinkClient>
                        </li>
                        <li>
                            <LocalizedLinkClient href={`/integration`} onClick={handleClose}>
                                {tekst('website:menu:addons')}
                            </LocalizedLinkClient>
                        </li>
                        <li>
                            <LocalizedLinkClient href={`/over-mkg`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:overmkg:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/over-mkg#vacatures`} onClick={handleClose} scrol={true}>
                                {tekst('website:menu:vacatures')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mijn-mkg/support`} prefetch={false}
                                  onClick={handleClose}>
                                {tekst('website:menu:support')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mijn-mkg/support`} prefetch={false} onClick={handleClose}>
                                {tekst('website:menu:mijnmkg')}
                            </LocalizedLinkClient>
                        </li>

                    <li>
                        <div id="vc-lang" className={style.vertalingContainer}>
                            {vertalingData?.map(vertaling => {
                                return <span key={`vertaling_a_${vertaling.taal.toLowerCase()}`}
                                             onClick={function () {
                                                 const lang = vertaling.taal.toLowerCase();
                                                 const localeFull = `${lang}-${getRegionFromLocale(locale)}`;

                                                 // Set cookie FIRST
                                                 document.cookie = `NEXT_LOCALE=${encodeURIComponent(localeFull)}; Path=/; Max-Age=31536000; SameSite=Lax`;

                                                 // Then call backend API
                                                 get(`/locale/${lang}`).then(response => {
                                                     if(response.status === 200) {
                                                         mutate(key => true);

                                                         // Get current path and translate segments
                                                         const currentPath = window.location.pathname;
                                                         const currentLocaleMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})(\/.*)?$/i);

                                                         if (currentLocaleMatch) {
                                                             const currentLocaleFull = currentLocaleMatch[1];
                                                             const currentLang = currentLocaleFull.split('-')[0];
                                                             const newLang = lang;
                                                             const restOfPath = currentLocaleMatch[2] || '';

                                                             // Remove locale slug from path
                                                             const cleanedPath = restOfPath;

                                                             // Reverse translate from current language to canonical form
                                                             const canonicalPath = reverseTranslateSegments(cleanedPath, currentLang);

                                                             // Translate to new language
                                                             const translatedPath = translateSegments(canonicalPath, newLang);

                                                             // Build new URL with translated path
                                                             window.location.href = `/${localeFull}${translatedPath}`;
                                                         } else {
                                                             // No locale in URL, just reload
                                                             window.location.reload();
                                                         }
                                                     }
                                                 });
                                             }}
                                             className={`${style.itemLangShort}`}>
                                     { vertaling.displayImage && <span
                                         className={`${vertaling.img_path} w-[32px] h-[24px]`}></span>}
                                                <div>{vertaling.taal}</div>
                                            </span>
                                })}
                            </div>
                        </li>
                    </ul>
                <div className={style.menuBottom}>
                    <ul>
                        <li><LocalizedLinkClient disabled href={`/disclaimer`} onClick={handleClose}>
                            Disclaimer
                        </LocalizedLinkClient></li>
                        <li><LocalizedLinkClient disabled href={`/sitemap`} onClick={handleClose}>
                            Sitemap
                        </LocalizedLinkClient></li>
                        <li><LocalizedLinkClient disabled href={`/privacy`} onClick={handleClose}>
                            Privacy
                        </LocalizedLinkClient></li>
                    </ul>
                    <div>
                        {tekst('website:menu:submenu:ondertekst')}
                    </div>
                </div>
                </div>
                }
            </div>
        </div>
}
